import { styled, Typography } from '@mui/material';
import { I18nStore } from '@tools/i18n/store';
import { injectTSDI } from '@tools/tsdi';
import { observer } from 'mobx-react';
import * as React from 'react';

import { StepButtons } from '../components/step-buttons';
import { SignupStore } from '../signup-store';

const Container = styled('div')({
    flexGrow: 1
});

const Section = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(5),
    '& .MuiTypography-gutterBottom': {
        marginBottom: theme.spacing(3)
    }
}));

export const SignupStep3 = observer(() => {
    const { translate, language } = injectTSDI(I18nStore);
    const { tenantURL, sendEvent, addtrackingProps } = injectTSDI(SignupStore);

    React.useEffect(() => {
        addtrackingProps({
            pageCategory: 'onboarding',
            pageName: 'Let’s go',
            lang: language
        });
    }, [addtrackingProps, language]);

    const onFinishSignup = () => {
        sendEvent('start_magicline');
        window.location.href = tenantURL;
    };

    return (
        <>
            <Container>
                <Typography variant="h4">
                    {translate('signup.done.title')}
                </Typography>
                <Section>
                    <Typography variant="subtitle2" gutterBottom>
                        {translate('signup.express.gratitude')}
                    </Typography>
                    <Typography variant="subtitle2">
                        {translate('signup.last.step.instruction')}
                    </Typography>
                </Section>
                <Section>
                    <Typography variant="subtitle1" gutterBottom>
                        {translate('signup.last.step.wish')}
                    </Typography>
                </Section>
            </Container>
            <StepButtons
                nextBtnLabel="signup.step3.next.button.label"
                data-role="finish-button"
                onNextBtnClick={onFinishSignup}
            />
        </>
    );
});
